import React from "react";

const BlogCard = ({ image, title, description, date, link }) => {
  return (
    <div
      className="blog-card border rounded-lg p-4 shadow-md h-650 cursor-pointer transition hover:shadow-lg"
      style={{ cursor: "pointer" }}
      onClick={() => (window.location.href = link)}
      role="link"
      tabIndex={0}
    >
      <img
        src={image}
        alt={title}
        className="w-full h-250 object-cover rounded"
      />
      <p className="text-sm text-gray-500 mt-2">Posted {date} ago</p>
      <h2 className="text-md font-semibold mt-1">{title}</h2>
      <p className="text-sm text-gray-700 mt-1">{description}</p>
      <a
        href={link}
        className="mt-3 px-4 py-1 border border-green-700 text-green-700 rounded hover:bg-green-700 hover:text-white transition inline-block"
        onClick={(e) => e.stopPropagation()}
      >
        READ MORE
      </a>
    </div>
  );
};

export default BlogCard;
